import React from 'react';
import { usePersistedDataStore } from '../../store';
import TablePollingComponent from '../shared/TablePollingComponent';

/**
 * Marketing table polling component - uses unified TablePollingComponent
 */
const MarketingTablePollingComponent = ({ 
  onDataUpdate,
  isFetching
}) => {
  const getMarketingResponse = usePersistedDataStore((state) => state.marketingResponse);
  const getTotalCases = usePersistedDataStore((state) => state.totalCases);
  const getIsFetching = usePersistedDataStore((state) => state.isFetching);

  return (
    <TablePollingComponent
      getData={() => getMarketingResponse}
      shouldPoll={() => {
        const currentData = getMarketingResponse;
        const currentIsFetching = getIsFetching || isFetching;
        const isDataComplete = getTotalCases !== null && 
                               getTotalCases > 0 && 
                               currentData && 
                               currentData.length >= getTotalCases;
        // Only poll if fetching/has data and not complete
        return (currentIsFetching || (currentData && currentData.length > 0)) && !isDataComplete;
      }}
      isComplete={(data) => {
        return getTotalCases !== null && 
               getTotalCases > 0 && 
               data && 
               data.length >= getTotalCases;
      }}
      onUpdate={(data, additionalState) => {
        const currentIsFetching = getIsFetching || isFetching;
        onDataUpdate({
          marketingResponse: data,
          totalCases: getTotalCases,
          isFetching: currentIsFetching
        });
      }}
      onComplete={(data, additionalState) => {
        onDataUpdate({
          marketingResponse: data,
          totalCases: getTotalCases,
          isFetching: false // Data is complete, no longer fetching
        });
      }}
      getAdditionalState={() => ({
        totalCases: getTotalCases,
        isFetching: getIsFetching || isFetching
      })}
      interval={1000}
      name="MarketingTablePolling"
      // enableLogging={true}
    />
  );
};

export default React.memo(MarketingTablePollingComponent);

